import { gatewayPhone } from "../../../../gateways/gatewayPhone";
import { updateCompanyCallFlowConfigSchema } from "../schemas/update-company-config";
import { UpdateCompanyCallFlowConfigPayload } from "../types/update-company-config";

export const updateCallFlow = async (
    companyId: number,
    payload: UpdateCompanyCallFlowConfigPayload,
) => {

    const parsed = updateCompanyCallFlowConfigSchema.parse(payload);

    const response = await gatewayPhone.patch(
        `company-call-config/${companyId}/config`,
        parsed
    );

    return response;
};